












import { Component, Vue, Watch } from "@/common";

@Component({})
export default class LangSelect extends Vue {
  get language() {
    return this.$store.state.app.language;
  }

  handleSetLanguage(lang) {
    this.$i18n.locale = lang;
    this.$store.dispatch("SetLanguage", lang);
    this.$message({
      message: "switch language success",
      type: "success"
    });
  }
}
